import { render, staticRenderFns } from "./researchCHForm.vue?vue&type=template&id=cab8c928&scoped=true&"
import script from "./researchCHForm.vue?vue&type=script&lang=js&"
export * from "./researchCHForm.vue?vue&type=script&lang=js&"
import style0 from "./researchCHForm.vue?vue&type=style&index=0&id=cab8c928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab8c928",
  null
  
)

export default component.exports